import { apiPrefix } from '../constants'

export default {
  login: {
    type: 'post',
    url: `${apiPrefix}user/login`,
  },
  logout: {
    type: 'post',
    url: `${apiPrefix}user/logout`,
  },
  getSessionStatus: {
    type: 'get',
    url: `${apiPrefix}user/loginStatus`,
  },
  refreshSession: {
    type: 'post',
    url: `${apiPrefix}user/refresh`,
  },
}
